import { Panel } from 'primereact/panel';
import { PepDecCpn } from '../../../models/cpn/PepDecCpn';
import { ClientePNService } from '../../../service/ClientePNService';
import { useForm } from 'react-hook-form';
import * as generic from '../../../components/Generico';
import { InputComponent } from '../../../components/InputComponent';
import { useEffect, useState } from 'react';
import { Divider } from 'primereact/divider';
import { ProgressSpinner } from 'primereact/progressspinner';
import { PepAfinidad } from '../common/PepAfinidad';
import { BottomActionBar } from '../../../components/ui/BottomActionBar';

export const PepPn = ({ id, toast, seccion, back, next, permss, catalogos, soloLectura }) => {

    const omodel = new PepDecCpn();
    const defaultValues = generic.funDefault(omodel.model);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues, setValue } = useForm({ defaultValues });
    const { inText, inNumber, inDrop, inCalendar } = InputComponent({ omodel, errors, control, permss, id, soloLectura });
    const clientepnSrv = new ClientePNService();
    const [esPep, setEsPep] = useState(false);
    const [relacionPep, setRelacionPep] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        editFicha();
        // eslint-disable-next-line
    }, [id]);

    const editFicha = () => {
        setIsLoading(true);
        clientepnSrv.consultarClientepn(id, seccion).then(res => {
            const _clientepn = res.data.clientepn;
            setEsPep(_clientepn.pep?.cat_id);
            setRelacionPep(_clientepn.esta_relacionado_pep?.cat_id);
            _clientepn.fecha_nombramiento_pep = generic.stringToDate(_clientepn.fecha_nombramiento_pep);
            _clientepn.fecha_dejo_pep = generic.stringToDate(_clientepn.fecha_dejo_pep);
            _clientepn.fecha_inicio_pep = generic.stringToDate(_clientepn.fecha_inicio_pep);
            _clientepn.fecha_fin_pep = generic.stringToDate(_clientepn.fecha_fin_pep);
            reset(generic.renewValues(_clientepn, omodel.model));
        }).finally(() => {
            setIsLoading(false)
        });
    }

    const onSubmit = (data) => {
        setIsSaving(true);
        data.seccion = seccion;
        data.id = id;
        if (esPep) {
            data.fecha_nombramiento_pep = data.fecha_nombramiento_pep.toISOString().split('T')[0];
            if (data.fecha_dejo_pep) {
                data.fecha_dejo_pep = data.fecha_dejo_pep.toISOString().split('T')[0];
            }
        } else {
            delete data.nombre_pep;
            delete data.cargo_pep;
            delete data.institucion_trabaja_pep;
            delete data.fecha_nombramiento_pep;
            delete data.fecha_dejo_pep;
        }
        if (relacionPep) {
            data.fecha_inicio_pep = data.fecha_inicio_pep.toISOString().split('T')[0];
            if (data.fecha_fin_pep) {
                data.fecha_fin_pep = data.fecha_fin_pep.toISOString().split('T')[0];
            }
        } else {
            delete data.vinculo_pep;
            delete data.nombre_vinculo_pep;
            delete data.cargo_vinculo_pep;
            delete data.institucion_vinculo_pep;
            delete data.fecha_inicio_pep;
            delete data.fecha_fin_pep;
        }

        clientepnSrv.editarClientepn(data).then(res => {
            generic.funcSuccess(res, toast);
            next();
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => setIsSaving(false));
    }

    const actualizarPatrimonio = (e) => {
        const actvs = ['ACTV_INMUEBLES', 'ACTV_MUEBLES', 'ACTV_EFECTIVO', 'ACTV_INVERSIONES', 'ACTV_CREDITOS', 'ACTV_OTROS'];
        const pasvs = ['PASV_BANCARIOS', 'PASV_HIPOTECARIOS', 'PASV_QUIROGRAFARIO', 'PASV_CREDITO', 'PASV_OTRAS_CTAS', 'PASV_OTROS_PASV'];
        let totalPasivos = 0;
        let totalActivos = 0;
        actvs.forEach(itm => {
            if (getValues(itm) && !isNaN(getValues(itm))) {
                totalActivos += parseFloat(getValues(itm));
            }
        });
        pasvs.forEach(itm => {
            if (getValues(itm) && !isNaN(getValues(itm))) {
                totalPasivos += parseFloat(getValues(itm));
            }
        });
        setValue('total_activos', totalActivos);
        setValue('total_pasivos', totalPasivos);
        setValue('total_patrimonio', totalActivos - totalPasivos);
    }

    const onChangePep = (e, esCampoPep) => {
        if (esCampoPep) {
            setEsPep(e.value?.cat_id);
            setValue('nombre_pep', '');
            setValue('cargo_pep', '');
            setValue('institucion_trabaja_pep', '');
            setValue('fecha_nombramiento_pep', null);
            setValue('fecha_dejo_pep', null);
        } else {
            setRelacionPep(e.value?.cat_id);
            setValue('vinculo_pep', '');
            setValue('nombre_vinculo_pep', '');
            setValue('cargo_vinculo_pep', '');
            setValue('institucion_vinculo_pep', '');
            setValue('fecha_inicio_pep', null);
            setValue('fecha_fin_pep', null);
        }
    }

    const onError = (errors) => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores, por favor revise el formulario para corregir.', life: 3000 });
    }

    if (isLoading) {
        return (
            <div className="flex flex-column align-items-center justify-content-center p-5">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" animationDuration=".5s" />
                <span className="mt-3 text-color-secondary font-medium text-lg">Consultando información...</span>
            </div>
        );
    }

    return (
        <div className="fadein animation-duration-300">
            <form id="pepPnForm" onSubmit={handleSubmit(onSubmit, onError)} className="p-fluid">

                <Panel header={generic.renderPanelHeader('A.5', 'PERSONA EXPUESTA POLÍTICAMENTE (PEP)', 'pi pi-shield')} className="panel-ficha shadow-1 mb-4">
                    <div className="field col-12 p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500 mb-4">
                        <div className="flex align-items-center gap-2 mb-3">
                            <i className="pi pi-info-circle text-blue-600 text-lg"></i>
                            <span className="font-bold text-blue-900">Definición de PEP</span>
                        </div>
                        {omodel.strPep}
                    </div>
                    <div className="col-12 mb-3 mt-3">
                        <div className="flex align-items-center">
                            <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                <i className="pi pi-user text-primary"></i>
                                CONDICIÓN DE PEP
                            </span>
                            <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                        </div>
                    </div>
                    <div className="formgrid grid mb-4">
                        {inDrop('pep', generic.estadosSiNo, { lab: omodel.optionLabel, chn: onChangePep, val: true }, 12)}
                        {esPep && (
                            <>
                                {inText('nombre_pep', { icon: 'pi pi-user' }, 6)}
                                {inText('cargo_pep', { icon: 'pi pi-briefcase' }, 6)}
                                {inText('institucion_trabaja_pep', { icon: 'pi pi-building' }, 12)}
                                {inCalendar('fecha_nombramiento_pep', {}, 6)}
                                {inCalendar('fecha_dejo_pep', { obl: 'no' }, 6)}
                            </>
                        )}
                    </div>
                    <div className="col-12 mb-3">
                        <div className="flex align-items-center">
                            <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                <i className="pi pi-users text-primary"></i>
                                FAMILIARES O RELACIONADOS
                            </span>
                            <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                        </div>
                    </div>
                    <div className="col-12 px-0 mb-4">
                        <PepAfinidad tipo='clientepn' id={id} toast={toast} permss={permss} catalogos={catalogos} soloLectura={soloLectura} />
                    </div>
                    <div className="col-12 mt-3 mb-3">
                        <div className="flex align-items-center">
                            <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                <i className="pi pi-share-alt text-primary"></i>
                                VÍNCULO CON UN PEP
                            </span>
                            <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                        </div>
                    </div>
                    <div className="formgrid grid">
                        {inDrop('esta_relacionado_pep', generic.estadosSiNo, { lab: omodel.optionLabel, chn: onChangePep, val: false }, 12)}
                        {relacionPep && (
                            <>
                                {inText('vinculo_pep', { icon: 'pi pi-link' }, 6)}
                                {inText('nombre_vinculo_pep', { icon: 'pi pi-user' }, 6)}
                                {inText('puesto_pep', { icon: 'pi pi-briefcase' }, 6)}
                                {inText('institucion_pep', { icon: 'pi pi-building' }, 6)}
                                {inCalendar('fecha_inicio_pep', {}, 6)}
                                {inCalendar('fecha_fin_pep', { obl: 'no' }, 6)}
                            </>
                        )}
                    </div>
                </Panel>

                <Panel header={generic.renderPanelHeader('A.6', 'DECLARACIÓN PATRIMONIAL SIMPLE', 'pi pi-chart-line')} className="panel-ficha shadow-1 mb-4">
                    <div className="grid formgrid mt-2">
                        <div className="col-12 md:col-6 mb-3 md:mb-0">
                            <div className="p-3 surface-50 border-round h-full flex flex-column shadow-1 border-1 border-300">
                                <div className="text-center text-primary font-bold mb-3 border-bottom-1 pb-2 text-lg">ACTIVOS</div>
                                <div className="formgrid grid flex-grow-1 align-content-start">
                                    {inNumber('ACTV_INMUEBLES', 2, true, { icon: 'pi pi-building', iconPosition: 'left', func: actualizarPatrimonio }, 12)}
                                    {inNumber('ACTV_MUEBLES', 2, true, { icon: 'pi pi-car', iconPosition: 'left', func: actualizarPatrimonio }, 12)}
                                    {inNumber('ACTV_EFECTIVO', 2, true, { icon: 'pi pi-money-bill', iconPosition: 'left', func: actualizarPatrimonio }, 12)}
                                    {inNumber('ACTV_INVERSIONES', 2, true, { icon: 'pi pi-chart-line', iconPosition: 'left', func: actualizarPatrimonio }, 12)}
                                    {inNumber('ACTV_CREDITOS', 2, true, { icon: 'pi pi-wallet', iconPosition: 'left', func: actualizarPatrimonio }, 12)}
                                    {inNumber('ACTV_OTROS', 2, true, { icon: 'pi pi-ellipsis-h', iconPosition: 'left', func: actualizarPatrimonio }, 12)}
                                </div>

                                <div className="mt-3">
                                    <Divider type="dashed" className="my-2" />
                                    <div className="bg-blue-50 p-2 border-round border-1 border-blue-200 formgrid grid mx-0">
                                        {inNumber('total_activos', 2, true, { icon: 'pi pi-chart-bar', iconPosition: 'left', disabled: true }, 12)}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 md:col-6">
                            <div className="p-3 surface-50 border-round h-full flex flex-column shadow-1 border-1 border-300">
                                <div className="text-center text-primary font-bold mb-3 border-bottom-1 pb-2 text-lg">PASIVOS</div>

                                <div className="formgrid grid flex-grow-1 align-content-start">
                                    {inNumber('PASV_BANCARIOS', 2, true, { icon: 'pi pi-building-columns', iconPosition: 'left', func: actualizarPatrimonio }, 12)}
                                    {inNumber('PASV_HIPOTECARIOS', 2, true, { icon: 'pi pi-home', iconPosition: 'left', func: actualizarPatrimonio }, 12)}
                                    {inNumber('PASV_QUIROGRAFARIO', 2, true, { icon: 'pi pi-file', iconPosition: 'left', func: actualizarPatrimonio }, 12)}
                                    {inNumber('PASV_CREDITO', 2, true, { icon: 'pi pi-credit-card', iconPosition: 'left', func: actualizarPatrimonio }, 12)}
                                    {inNumber('PASV_OTRAS_CTAS', 2, true, { icon: 'pi pi-list', iconPosition: 'left', func: actualizarPatrimonio }, 12)}
                                    {inNumber('PASV_OTROS_PASV', 2, true, { icon: 'pi pi-ellipsis-h', iconPosition: 'left', func: actualizarPatrimonio }, 12)}
                                </div>

                                <div className="mt-3">
                                    <Divider type="dashed" className="my-2" />
                                    <div className="bg-blue-50 p-2 border-round border-1 border-blue-200 formgrid grid mx-0">
                                        {inNumber('total_pasivos', 2, true, { icon: 'pi pi-chart-bar', iconPosition: 'left', disabled: true }, 12)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="grid mt-4">
                        <div className="col-12 md:col-6 md:col-offset-3">
                            <div className="bg-blue-100 p-3 border-round border-1 border-blue-300 shadow-2 formgrid grid mx-0">
                                {inNumber('total_patrimonio', 2, true, { icon: 'pi pi-wallet', iconPosition: 'left', disabled: true, min: -10000000000000 }, 12)}
                            </div>
                        </div>
                    </div>
                </Panel>

                <BottomActionBar formId="pepPnForm" onPrev={back} onNext={next} loading={isSaving} isReadOnly={soloLectura} />
            </form>
        </div>
    )
}
